import React, { useState, useEffect } from "react";
import logo from "./../../src/assets/locoachelear2.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import "./Home.css";
import "./Soporte.css";

const EMAIL = "administrador@achelear.com";

function EmailMenu({ onGmail, onCopy, dark = false }: {
  onGmail: () => void;
  onCopy: () => void;
  dark?: boolean;
}) {
  return (
    <div className={`email-menu ${dark ? "email-menu--dark" : ""}`} onClick={(e) => e.stopPropagation()}>
      <button className="email-menu__item" onClick={onGmail}>
        <span className="email-menu__icon">
          <svg width="18" height="18" viewBox="0 0 48 48" fill="none">
            <path d="M44 24.5c0-1.2-.1-2.4-.3-3.5H24v6.6h11.3a9.7 9.7 0 01-4.2 6.4v5.3h6.8C41.8 35.7 44 30.5 44 24.5z" fill="#4285F4"/>
            <path d="M24 45c5.7 0 10.5-1.9 14-5.1l-6.8-5.3c-1.9 1.3-4.3 2-7.2 2-5.5 0-10.2-3.7-11.9-8.8H5.1v5.5A21 21 0 0024 45z" fill="#34A853"/>
            <path d="M12.1 27.8A12.6 12.6 0 0111.5 24c0-1.3.2-2.6.6-3.8v-5.5H5.1A21 21 0 003 24c0 3.4.8 6.6 2.1 9.3l7-5.5z" fill="#FBBC05"/>
            <path d="M24 11.4c3.1 0 5.9 1.1 8.1 3.2l6-6A21 21 0 0024 3 21 21 0 005.1 14.7l7 5.5C13.8 15.1 18.5 11.4 24 11.4z" fill="#EA4335"/>
          </svg>
        </span>
        Abrir Gmail
      </button>
      <div className="email-menu__divider" />
      <button className="email-menu__item" onClick={onCopy}>
        <span className="email-menu__icon">📋</span>
        Copiar dirección
      </button>
    </div>
  );
}

function Soporte() {
  const [scrolled, setScrolled] = useState(false);
  const [copied, setCopied] = useState(false);
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!openMenu) return;
    const close = () => setOpenMenu(null);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [openMenu]);

  const openGmail = () => {
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${EMAIL}`,
      "_blank"
    );
    setOpenMenu(null);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(EMAIL).then(() => {
      setCopied(true);
      setOpenMenu(null);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const toggleMenu = (id: string) => (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenMenu((prev) => (prev === id ? null : id));
  };

  const faqs = [
    {
      q: "¿Cómo reporto un error?",
      a: "Mándanos un correo describiendo qué pasó, en qué pantalla ocurrió y qué dispositivo usas. Con esa info lo resolvemos mucho más rápido.",
    },
    {
      q: "¿Por qué la app no encuentra lugares cerca de mí?",
      a: "Asegúrate de tener los permisos de ubicación activados para A Chelear en la configuración de tu teléfono. La app necesita acceso a tu ubicación para mostrar resultados.",
    },
    {
      q: "¿Está disponible para iPhone?",
      a: "¡Sí! A Chelear está disponible tanto en Android (Google Play) como en iPhone (App Store). Descárgala gratis desde cualquiera de las tiendas.",
    },
    {
      q: "¿Cómo puedo dar de alta mi negocio?",
      a: "Escríbenos a nuestro correo de soporte indicando el nombre, dirección y tipo de negocio. Nos ponemos en contacto contigo a la brevedad.",
    },
  ];

  return (
    <div className="home">
      {/* NAVBAR */}
      <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""} navbar--solid`}>
        <div className="navbar__container">
          <div className="navbar__brand" onClick={() => window.location.href = "/"}>
            <img src={logo} alt="A Chelear" className="navbar__logo" />
            <span className="navbar__name">A Chelear</span>
          </div>
          <ul className="navbar__links">
            <li onClick={() => window.location.href = "/"}>Inicio</li>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61559163846604"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar__fb"
              >
                <FacebookIcon fontSize="small" />
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* HERO SOPORTE */}
      <section className="soporte-hero">
        <div className="soporte-hero__bg-circles">
          <span className="circle circle--1" />
          <span className="circle circle--2" />
        </div>
        <div className="soporte-hero__content">
          <span className="hero__badge">🛠️ Centro de ayuda</span>
          <h1 className="hero__title">
            ¿En qué podemos<br />
            <span className="hero__highlight">ayudarte?</span>
          </h1>
          <p className="hero__desc">
            Tienes algún problema, duda o sugerencia con la app.<br />
            Estamos para ayudarte.
          </p>
          <div className="email-menu-wrap" style={{ position: "relative", display: "inline-block" }}>
            <button className="btn btn--primary soporte-hero__cta" onClick={toggleMenu("hero")}>
              ✉️ Enviar un correo
            </button>
            {openMenu === "hero" && <EmailMenu onGmail={openGmail} onCopy={handleCopy} />}
          </div>
        </div>
      </section>

      {/* CONTACTO */}
      <section className="soporte-contact">
        <div className="section-container">
          <div className="soporte-contact__card">
            <div className="soporte-contact__icon">📬</div>
            <div className="soporte-contact__text">
              <h2>Escríbenos directamente</h2>
              <p>
                Te respondemos lo antes posible,<br />
                normalmente en <strong>24 a 48 horas</strong>.
              </p>
            </div>
            <div className="soporte-email-block">
              <span className="soporte-email-address">{EMAIL}</span>
              <div className="soporte-email-btns" style={{ position: "relative" }}>
                <button className="btn btn--primary" onClick={toggleMenu("contact")}>
                  ✉️ Enviar correo
                </button>
                <button className="btn btn--ghost-dark" onClick={handleCopy}>
                  {copied ? "✅ ¡Copiado!" : "📋 Copiar"}
                </button>
                {openMenu === "contact" && <EmailMenu onGmail={openGmail} onCopy={handleCopy} />}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="soporte-faq">
        <div className="section-container">
          <span className="section-label">Lo que más nos preguntan</span>
          <h2 className="section-title">Preguntas frecuentes</h2>
          <div className="faq__grid">
            {faqs.map((faq, i) => (
              <div className="faq-card" key={i}>
                <div className="faq-card__number">{i + 1}</div>
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="download">
        <div className="download__container">
          <div className="download__text">
            <h2>¿No encontraste lo que buscabas?</h2>
            <p>
              Nuestro equipo está listo para ayudarte. Escríbenos y
              resolvemos tu duda juntos.
            </p>
            <div className="download__btns" style={{ position: "relative" }}>
              <button className="btn btn--orange" onClick={toggleMenu("cta")}>
                ✉️ Contactar soporte
              </button>
              <button className="btn btn--outline-white" onClick={handleCopy}>
                {copied ? "✅ ¡Correo copiado!" : "📋 Copiar correo"}
              </button>
              {openMenu === "cta" && <EmailMenu onGmail={openGmail} onCopy={handleCopy} dark />}
            </div>
          </div>
          <div className="download__image">
            <img src={logo} alt="A Chelear" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer__container">
          <div className="footer__brand">
            <img src={logo} alt="A Chelear" className="footer__logo" />
            <p>Tu directorio de bares y cervecerías</p>
          </div>
          <div className="footer__links">
            <a href="https://achelear.com.mx/avisoPrivacidad" target="_blank" rel="noopener noreferrer">
              Aviso de privacidad
            </a>
            <a href="https://www.facebook.com/profile.php?id=61559163846604" target="_blank" rel="noopener noreferrer">
              <FacebookIcon fontSize="small" style={{ marginRight: 4 }} />
              Facebook
            </a>
          </div>
          <p className="footer__copy">
            © {new Date().getFullYear()} A Chelear. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      {/* TOAST copiado */}
      {copied && (
        <div className="soporte-toast">
          ✅ Correo copiado al portapapeles
        </div>
      )}
    </div>
  );
}

export default Soporte;
